





import { computed, defineComponent, PropType } from '@vue/composition-api';
import { CompanyLegalType } from '@/graphql';
import { companyLegalTypes } from '@/constants';

export default defineComponent({
  props: {
    legalType: {
      type: String as PropType<CompanyLegalType>,
      required: true,
    },
    small: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const legalTypeProps: { [key: string]: object } = Object.fromEntries(
      Object.entries(companyLegalTypes).map(([key, value]) => [
        key,
        {
          color: 'blue lighten-1',
          textColor: 'white',
          label: value,
        },
      ]),
    );

    return {
      state: computed(() => {
        return (
          legalTypeProps[props.legalType] || {
            color: 'grey',
            textColor: 'white',
            label: props.legalType || 'Unbekannt',
          }
        );
      }),
    };
  },
});
